export default "__VITE_ASSET__B5CFpqad__"